import { paginationStyles } from "@insite/content-library/Widgets/ProductList/ProductListPagination";
import { css } from "styled-components";

/**** EC-421 - PLP ****

*** Start: Refactored dynamic CSS from CMS to code for consistent behavior across environments. */

paginationStyles.pagination = {
    selectProps: {
        labelProps: {
            css: css`
                min-height: 22px;
                display: inline-block;
                text-align: right;
                padding: 9px 15px 0px 0px;
                width: 196px;
                font-size: 15px;
                font-weight: 600;
            `,
        },
    },
    buttonProps: {
        css: css`
            color: rgb(0, 0, 0);
            font-size: 15px;
            text-transform: uppercase;
            font-weight: 500;
            border: none;
        `,
    },
};

/* *** End: Dynamic CSS refactoring complete. Apply future updates here instead of the CMS.*/
